import { render, staticRenderFns } from "./DeviceTop10.vue?vue&type=template&id=0cbd2a2c&scoped=true"
import script from "./DeviceTop10.vue?vue&type=script&lang=js"
export * from "./DeviceTop10.vue?vue&type=script&lang=js"
import style0 from "./DeviceTop10.vue?vue&type=style&index=0&id=0cbd2a2c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cbd2a2c",
  null
  
)

export default component.exports